<template>
    <div class="contact">
        <img style="height: 450px;width:100%;" src="../../assets/05-recruit/01-banner.jpg" alt="">
        <div style="padding: 50px 440px;">
            <div style="font-size: 28px;margin-bottom: 25px;" class="color-97">招贤纳士</div>
            <div style="padding: 25px 0; text-align: left;">
                <div style="font-size: 18px; margin-bottom: 18px;" class="color-113-188">后端研发工程师</div>
                <div class="color-69">
                    <div>[岗位要求]</div>
                    <div>1、计算机或相关专业，本科及以上学历(硬性条件);</div>
                    <div>2、2年以上java开发经验，主导过项目开发实施经验的优先;</div>
                    <div>3、熟悉MVC结构设计，熟悉基于Web和数据库的应用程序开发;</div>
                    <div>4、熟悉面向对象编程原理，熟悉SpringCloud、Springboot、zookeeper、kafka、 vue等技术</div>
                    <div>5、熟悉mysal等至少一种关系数据库，熟练使用SQL语言;</div>
                    <div>6、有公安、政企项目经验优先。</div>
                </div>
            </div>
            <div style="padding: 25px 0; text-align: left;">
                <div style="font-size: 18px; margin-bottom: 18px;" class="color-113-188">前端研发工程师</div>
                <div class="color-69">
                    <div>[岗位要求]</div>
                    <div>1、计算机相关专业，统招本科(硬性条件)，2-3年以上相关经验;</div>
                    <div>2、能对系统前端的性能、架构进行深入优化，提高系统性能、可靠性，及可扩展性;</div>
                    <div>3、熟悉Javascript/CSS、OP 及主流前端类库、框架、工具，如jQuery，React，vue 等，有框架开发或贡献经验者优先;</div>
                    <div>4、使用HTML5、CSS3、OOP JavaScript、 vue、React等最新网络技术开发PC/Mobile端应用;</div>
                    <div>5、熟悉Echarts.is;</div>
                    <div>6、具有良好的代码风格、接口设计与程序架构，较强的学习能力，良好的沟通能力，具备良好的知识沉淀习惯;</div>
                    <div>7、有公安、政企项目经验优先。</div>
                </div>
            </div>
            <div style="padding: 25px 0; text-align: left;">
                <div style="font-size: 18px; margin-bottom: 18px;" class="color-113-188">项目开发经理</div>
                <div class="color-69">
                    <div>[岗位职责]</div>
                    <div>1、主要从事Java项目开发和管理工作;</div>
                    <div>2、参与项目设计和建设，参与需求分析，架构设计和开发，并确保项目的开发质量与进度;</div>
                    <div>3、具备较强的学习、分析问题和解决问题的能力;具备良好的团队合作精神，能够制定合理的问题解决方案，组织或协调多方资源有效进行解决;</div>
                    <div>4、良好的沟通能力，有较好的文档编写及汇报能力。</div>
                    <div style="margin-bottom: 18px;">5、能接受加班与出差。</div>
                    <div>[岗位要求]</div>
                    <div>1、统招本科及以上学历，计算机相关专业;从事Java开发工作3年以上，有丰富的Java开发经验; (学信网可查)</div>
                    <div>2、掌握Linux操作系统常用的操作命令;</div>
                    <div>3、熟练使用oracle、mysal等主流数据库，掌握PL/SQL语言编程及SQL优化;</div>
                    <div>4、熟悉主流开源框架，如SpringMVC、SpringBoot、MyBatis等，并有实际项目开发经验;</div>
                    <div>5、熟练掌握工作流引擎(Activiti或者Flowable)，熟悉POI等文档处理技术，有在线文档阅读和在线编辑的项目经验者优先;</div>
                    <div>6、熟练掌握vue技术栈开发，熟悉流行的框架比如: Jeecg，Ant Degsin Vue等，并有实际项目开发经验;</div>
                    <div>7、有公安或者政府行业经验者，或者带项目经验者优先</div>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import foot from '../../components/foot'
import {WOW} from 'wowjs'
export default {
    data:function(){
        return {
            
        }
    },
    components:{
        foot,
    },
    methods:{

    },
}
</script>


<style lang="less" scoped>
.color-97 {
    color: rgb(97, 97, 97);
}

.color-69 {
    color: rgb(69, 69, 69);
}

.color-113-188 {
    color: rgb(0, 113, 188);
}
</style>










// WEBPACK FOOTER //
// src/views/contact/contact.vue